@if (!isExpandStructure) {
  <div class="row containerIn">
    <div class="columns stats_one">
      <div class="columns stats_container">
        <div class="medium-3 sequence_match_lable_first">Sequence match</div>
        <div class="columns small-5 medium-2 sequence_match_lable_hsp"><span>HSP score:</span> {{getLabelValue('HSP score', res.sequence_stats)}}</div>
        <div class="columns small-5 medium-2 sequence_match_lable_last"><span>E-value: </span>{{getLabelValue('E-value', res.sequence_stats)}}</div>
      </div>
    </div>
    <div class="columns stats_two">
      <div class="columns stats_container">
        <div class="medium-3 sequence_match_lable_first">&nbsp;</div>
        <div class="columns  small-5  medium-2 sequence_match_lable_hsp"><span>Identity:</span> {{getLabelValue('Identity', res.sequence_stats)}}</div>
        <div class="sequence_match_lable_postives"><span>Positives:</span> {{getLabelValue('Positives', res.sequence_stats)}}</div>
        <div class="columns medium-2 sequence_match_lable_last"><span>Gaps: </span>{{getLabelValue('Gaps', res.sequence_stats)}}</div>
      </div>
    </div>
    <div class="columns" [ngClass]="isExpandStructure ? 'sequence_row_second-struct' : 'sequence_row_second-bg sequence_row_second'">
      <div class="columns" style="display:inline-block; padding-left:0px;">
        @if (!greaterThanLimit(res.query_sequence)) {
          <div class="columns sequence_container" [ngClass]="isExpandStructure ? 'sequence_row_second-strcuture-bg' : 'sequence_row_second-bg'">
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query">Your query</div>
              <div class="small-10 sequence_query">
                <span class="sequence_stat_num">1</span>
                <p style="white-space:nowrap;">{{ res.query_sequence | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">{{res.query_sequence.length}}</span>
              </div>
            </div>
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query"></div>
              <div class="small-10 sequence_query">
                <span class="sequence_stat_num"> &nbsp;</span>
                <p style="white-space:pre-wrap;">{{ match_sequence | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">&nbsp;</span>
              </div>
            </div>
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query">{{res.accession}}</div>
              <div class="small-10 sequence_query">
                <span class="sequence_stat_num">1</span>
                <p style="white-space:nowrap;">{{ res.match_accession | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">{{res.match_accession.length}}</span>
              </div>
            </div>
          </div>
        }
        @if (greaterThanLimit(res.query_sequence) && canShowSingle) {
          <div class="columns sequence_container">
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query">Your query</div>
              <span class="sequence_stat_num">1</span>
              <div class="small-10 sequence_query">
                <p style="white-space:nowrap;">{{ res.query_sequence | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">{{sequenceSliceLimit}}</span>
              </div>
            </div>
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query"></div>
              <span class="sequence_stat_num"></span>
              <div class="small-10 sequence_query">
                <p style="white-space:pre-wrap;">{{ match_sequence | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">&nbsp;</span>
              </div>
            </div>
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query">{{res.accession}}</div>
              <span class="sequence_stat_num">1</span>
              <div class="small-10 sequence_query">
                <p style="white-space:nowrap;">{{ res.match_accession | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">{{sequenceSliceLimit}}</span>
              </div>
            </div>
          </div>
        }
        @if (greaterThanLimit(res.query_sequence) && canShowAll) {
          <div>
            @for (querystring of getStringsChunks(res.query_sequence); track querystring) {
              <div class="columns sequence_container">
                <div style="display: flex;">
                  <div class="small-2 sequence_stat_query">Your query</div>
                  <span class="small-1 sequence_stat_num">{{querystring.start}}</span>
                  <div class="small-10 sequence_query">
                    <p style="white-space:nowrap;">{{ querystring.query_chunk }}</p>
                    <span class="sequence_query_length">{{querystring.counttoshow}}</span>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="small-2 sequence_stat_query"></div>
                  <span class="sequence_stat_num"></span>
                  <div class="small-10 sequence_query">
                    <p style="white-space:pre-wrap;">{{ match_sequence | slice: querystring.start-1:querystring.counttoshow }}</p>
                    <span class="sequence_query_length">&nbsp;</span>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="small-2 sequence_stat_query">{{res.accession}}</div>
                  <span class="sequence_stat_num">{{querystring.start}}</span>
                  <div class="small-10 sequence_query">
                    <p style="white-space:nowrap;">{{ res.match_accession | slice: querystring.start-1:querystring.counttoshow }}</p>
                    <span class="sequence_query_length">{{querystring.counttoshow}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (greaterThanLimit(res.query_sequence)) {
          <div class="flexititle">
            @if (isShowingAll) {
              <a class="showMoreLink" (click)="switchTexttoFull(text)">Show full alignment
                <svg class="showicon" viewBox="0 0 25 25">
                  <path fill="currentColor"
                    d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
                </svg>
              </a>
            }
            @if (!isShowingAll) {
              <a class="showMoreLink" (click)="switchTexttoLess(text)">Show less
                <svg class="showicon" viewBox="0 0 25 25">
                  <path fill="currentColor"
                    d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"/>
                </svg>
              </a>
            }
          </div>
        }
      </div>
    </div>
  </div>
}

@if (isExpandStructure) {
  <div class="row containerIn">
    <div class="columns" [ngClass]="isExpandStructure ? 'sequence_row_second-struct' : 'sequence_row_second-bg sequence_row_second'">
      <div class="columns" style="display:inline-block; padding-left:0px;">
        @if (!greaterThanLimit(res.query_sequence)) {
          <div class="columns sequence_container" [ngClass]="isExpandStructure ? 'sequence_row_second-strcuture-bg' : 'sequence_row_second-bg'">
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query_struct">{{res.current_entry}}</div>
              <div class="small-10 sequence_query">
                <span class="sequence_stat_num_struct">{{res.qstart}}</span>
                <p style="white-space:nowrap;">{{ res.query_sequence | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">{{ (res.qstart-1) + queryLengthWithoutDash(res.query_sequence) }}</span>
              </div>
            </div>
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query_struct"></div>
              <div class="small-10 sequence_query">
                <span class="sequence_stat_num_struct"> &nbsp;</span>
                <p style="white-space:pre-wrap;">{{ match_sequence | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">&nbsp;</span>
              </div>
            </div>
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query_struct">{{res.targetToShow}}</div>
              <div class="small-10 sequence_query">
                <span class="sequence_stat_num_struct">{{res.tstart}}</span>
                <p style="white-space:nowrap;">{{ res.match_accession | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">{{ (res.tstart-1) + queryLengthWithoutDash(res.match_accession) }}</span>
              </div>
            </div>
          </div>
        }
        @if (greaterThanLimit(res.query_sequence) && canShowSingle) {
          <div class="columns sequence_container">
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query_struct">{{res.current_entry}}</div>
              <span class="sequence_stat_num_struct">{{res.qstart}}</span>
              <div class="small-10 sequence_query">
                <p style="white-space:nowrap;">{{ res.query_sequence | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">{{ (res.qstart-1) + (sequenceSliceLimit - countDashes(res.query_sequence | slice:0:sequenceSliceLimit)) }}</span>
              </div>
            </div>
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query_struct"></div>
              <span class="sequence_stat_num_struct"></span>
              <div class="small-10 sequence_query">
                <p style="white-space:pre-wrap;">{{ match_sequence | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">&nbsp;</span>
              </div>
            </div>
            <div style="display: flex;">
              <div class="small-2 sequence_stat_query_struct">{{res.targetToShow}}</div>
              <span class="sequence_stat_num_struct">{{res.tstart}}</span>
              <div class="small-10 sequence_query">
                <p style="white-space:nowrap;">{{ res.match_accession | slice:0:sequenceSliceLimit }}</p>
                <span class="sequence_query_length">{{ (res.tstart-1) + (sequenceSliceLimit - countDashes(res.match_accession | slice:0:sequenceSliceLimit)) }}</span>
              </div>
            </div>
          </div>
        }
        @if (greaterThanLimit(res.query_sequence) && canShowAll) {
          <div>
            @for (querystring of getStringsChunksForStructure(res.qstart, res.query_sequence, res.tstart, res.match_accession); track querystring) {
              <div class="columns sequence_container">
                <div style="display: flex;">
                  <div class="small-2 sequence_stat_query_struct">{{res.current_entry}}</div>
                  <span class="small-1 sequence_stat_num_struct">{{querystring.qstart}}</span>
                  <div class="small-10 sequence_query">
                    <p style="white-space:nowrap;">{{ querystring.query_chunk }}</p>
                    <span class="sequence_query_length">{{querystring.qcounttoshow}}</span>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="small-2 sequence_stat_query_struct"></div>
                  <span class="sequence_stat_num_struct"></span>
                  <div class="small-10 sequence_query">
                    <p style="white-space:pre-wrap;">{{ match_sequence | slice: querystring.start-1:querystring.counttoshow  }}</p>
                    <span class="sequence_query_length">&nbsp;</span>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="small-2 sequence_stat_query_struct">{{res.targetToShow}}</div>
                  <span class="sequence_stat_num_struct">{{querystring.tstart}}</span>
                  <div class="small-10 sequence_query">
                    <p style="white-space:nowrap;">{{ querystring.target_chunk }}</p>
                    <span class="sequence_query_length">{{querystring.tcounttoshow}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (greaterThanLimit(res.query_sequence)) {
          <div class="flexititle-struct">
            <span class="gaptext">A dash “-” indicates an unmatched region due to a lack of alignment
              <br>or missing model coordinates for structures from the PDB.
              </span>
              @if (isShowingAll) {
                <a class="showMoreLink" (click)="switchTexttoFull(text)">Show full alignment
                  <svg class="showicon" viewBox="0 0 25 25">
                    <path fill="currentColor"
                      d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
                  </svg>
                </a>
              }
              @if (!isShowingAll) {
                <a class="showMoreLink" (click)="switchTexttoLess(text)">Show less
                  <svg class="showicon" viewBox="0 0 25 25">
                    <path fill="currentColor"
                      d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"/>
                  </svg>
                </a>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
